module.exports = __webpack_public_path__ + "img/Keller6.bdbb3ea8.jpeg";